import { useState, useEffect } from "react";
import { Header } from "../components/header";
import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";

import { Slider } from "../components/slider";
import { About } from "../components/about";
import { Services } from "../components/services";
import { Working } from "../components/working";
import { Features } from "../components/features";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});


const Home = () => {

  return (
    <div>
      <Slider />
      <About />
      <Services />
      <Working />
      <Features />

      

    </div>
  );

}


export default Home;
